const getMatchingVariant = (selectedOptions, variantsData, optionNames) => {
  if (variantsData.length === 1) return variantsData[0];

  return variantsData.find((variant) =>
    optionNames.every((name, i) => selectedOptions[name] === variant[`option${i + 1}`])
  );
};

export default getMatchingVariant;
